/** Minimal money shape — mirrors `@jod/schemas` Money without coupling the UI kit to it. */
export interface MoneyLike {
  amountMinor: number;
  currency: string;
}

/**
 * Format an integer minor-unit amount (satang) as a Thai-baht price string.
 * Whole baht render without decimals ("฿120"); fractional show two ("฿120.50").
 */
export function formatBaht(amountMinor: number): string {
  const baht = amountMinor / 100;
  const hasFraction = amountMinor % 100 !== 0;
  const formatted = baht.toLocaleString("th-TH", {
    minimumFractionDigits: hasFraction ? 2 : 0,
    maximumFractionDigits: 2,
  });
  return `฿${formatted}`;
}

/** Format a schema `Money` value. Falls back to the bare symbol for THB. */
export function formatMoney(money: MoneyLike): string {
  if (money.currency === "THB") return formatBaht(money.amountMinor);
  const major = money.amountMinor / 100;
  return `${major.toLocaleString()} ${money.currency}`;
}
